<mat-card>
  <mat-card-content>
    <div [style.display]="dataUrl ? 'flex' : 'none'" class="pdf-preview">
      <button mat-flat-button color="primary" (click)="onGenerateInvoice()">Télécharger le devis</button>
      <iframe id="pdfPreview" src="" width="100%" height="90%"></iframe>
    </div>
    <span [style.display]="!dataUrl ? 'flex' : 'none'" class="no-pdf">Aucun devis généré. Cliquez sur générer le devis</span>
  </mat-card-content>
</mat-card>
